import { apiFetch } from "../../http";
const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const getApiMessage = (payload, fallback) => {
    if (!payload)
        return fallback;
    if (typeof payload === "string")
        return payload;
    if (typeof payload === "object") {
        const data = payload;
        if (typeof data.error === "string" && data.error)
            return data.error;
        if (typeof data.message === "string" && data.message)
            return data.message;
        if (typeof data.detail === "string" && data.detail)
            return data.detail;
        if (typeof data.errors === "string" && data.errors)
            return data.errors;
        if (data.errors && typeof data.errors === "object") {
            const values = Object.values(data.errors).filter(Boolean);
            if (values.length)
                return values.join(", ");
        }
    }
    return fallback;
};
export async function saveTravelDescriptionText(params) {
    const { baseUrl, travelPlanId, text, mode, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_description_text_created/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
        },
        body: JSON.stringify({
            text,
            ...(mode ? { mode } : {})
        })
    });
}
export async function uploadTravelDescriptionImages(params) {
    const { baseUrl, travelPlanId, images, captions, token, csrfToken } = params;
    const formData = new FormData();
    images.forEach((file) => formData.append("images", file));
    formData.append("captions", JSON.stringify(captions));
    return apiFetch(`/travel/api/travel_description_image_created/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined,
        body: formData
    });
}
export async function deleteTravelDescriptionImage(params) {
    const { baseUrl, travelPlanId, mediaId, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_description_image_delete/${travelPlanId}/${mediaId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined
    });
}
export async function getTravelDescription(params) {
    const { baseUrl, travelPlanId, token } = params;
    return apiFetch(`/travel/api/get_travel_description/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "GET"
    });
}
export async function getTravelPlanItems(params) {
    const { baseUrl, travelPlanId, token } = params;
    return apiFetch(`/travel/api/travel_plan_items/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "GET",
        cache: "no-store"
    });
}
export async function getTravelPlanLimits(params) {
    const { baseUrl, travelPlanId, token } = params;
    return apiFetch(`/travel/api/get_travel_plan_limits/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "GET"
    });
}
export async function getTravelPackagesCatalog(params) {
    const { baseUrl, token } = params;
    return apiFetch(`/api/dict_travel_packages_by_type/`, {
        baseUrl,
        token,
        method: "GET"
    });
}
export async function getTravelCardGptTaskStatus(params) {
    const { baseUrl, travelPlanId, taskId, token, statusEndpoint = "auto" } = params;
    if (statusEndpoint === "external") {
        return apiFetch(`/external_services/api/gpt/task-status/${travelPlanId}/${taskId}/`, {
            baseUrl,
            token,
            method: "GET"
        });
    }
    if (statusEndpoint === "default") {
        return apiFetch(`/api/gpt/task-status/${travelPlanId}/${taskId}/`, {
            baseUrl,
            token,
            method: "GET"
        });
    }
    try {
        return await apiFetch(`/api/gpt/task-status/${travelPlanId}/${taskId}/`, {
            baseUrl,
            token,
            method: "GET"
        });
    }
    catch (error) {
        if (Number(error === null || error === void 0 ? void 0 : error.status) !== 404) {
            throw error;
        }
        return apiFetch(`/external_services/api/gpt/task-status/${travelPlanId}/${taskId}/`, {
            baseUrl,
            token,
            method: "GET"
        });
    }
}
export async function waitTravelCardGptTaskSuccess(params) {
    var _a;
    const { baseUrl, travelPlanId, taskId, token, statusEndpoint = "auto", firstStatusDelayMs = 30 * 1000, intervalMs = 10 * 1000, timeoutMs = 60 * 60 * 1000, timeoutMessage = "Обработка еще идет. Обновите позже.", failureMessage = "Ошибка обработки.", } = params;
    const startedAt = Date.now();
    await sleep(firstStatusDelayMs);
    while (Date.now() - startedAt <= timeoutMs) {
        const statusResp = await getTravelCardGptTaskStatus({
            baseUrl,
            travelPlanId,
            taskId,
            token,
            statusEndpoint,
        });
        const status = String((statusResp === null || statusResp === void 0 ? void 0 : statusResp.status) || "").toUpperCase();
        if (status === "SUCCESS") {
            return (_a = statusResp === null || statusResp === void 0 ? void 0 : statusResp.result) !== null && _a !== void 0 ? _a : statusResp;
        }
        if (status === "FAILURE") {
            const errorPayload = (statusResp === null || statusResp === void 0 ? void 0 : statusResp.result) && typeof statusResp.result === "object"
                ? statusResp.result
                : statusResp;
            throw new Error(getApiMessage(errorPayload, failureMessage));
        }
        await sleep(intervalMs);
    }
    throw new Error(timeoutMessage);
}
export async function deleteItemTravel(params) {
    const { baseUrl, travelPlanId, itemId, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_plan_item_deleted/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
        // важно: тело нужно, иначе твой view вернёт 400
        body: JSON.stringify({ id: itemId }),
    });
}
export async function deleteAllTravelPlanItems(params) {
    const { baseUrl, travelPlanId, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_plan_items_deleted_all/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined
    });
}
export async function deleteTravelItemsByGroup(params) {
    const { baseUrl, travelPlanId, rangeGroupId, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_plan_items_deleted_by_group/${travelPlanId}/${rangeGroupId}/`, {
        baseUrl,
        token,
        method: "DELETE",
        headers: csrfToken ? { "X-CSRFToken": csrfToken } : undefined
    });
}
// CREATE
export async function createItemTravel(params) {
    const { baseUrl, travelPlanId, fd, token, csrfToken } = params;
    return apiFetch(`/travel/api/item_travel_created/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "POST",
        headers: {
            // НЕ ставим Content-Type вручную для FormData!
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
        body: fd,
    });
}
// UPDATE
export async function updateItemTravel(params) {
    const { baseUrl, travelPlanId, itemId, fd, token, csrfToken } = params;
    // важно: передай itemId так, как ждёт Django view
    // если view ждёт body {id: ...} — можно положить в fd:
    fd.append("id", String(itemId)); // или "item_id" — смотри твой view
    return apiFetch(`/travel/api/travel_plan_item_updated/${travelPlanId}/`, {
        baseUrl,
        token,
        method: "PATCH",
        headers: {
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {}),
        },
        body: fd,
    });
}
export async function updateTravelPlanGroupDayTitle(params) {
    const { baseUrl, travelPlanId, travelDayId, dayTitle, token, csrfToken } = params;
    return apiFetch(`/travel/api/travel_day_title_updated/${travelPlanId}/${travelDayId}/`, {
        baseUrl,
        token,
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
            ...(csrfToken ? { "X-CSRFToken": csrfToken } : {})
        },
        body: JSON.stringify({ title: dayTitle })
    });
}
